/* eslint-disable react/require-default-props */
import PropTypes from 'prop-types';
import React from 'react';
import { change, fieldInputPropTypes, fieldMetaPropTypes } from 'redux-form';
import DayPickerInput from 'react-day-picker/DayPickerInput';
import format from 'date-fns/format';

import 'react-day-picker/lib/style.css';
import './DateInput.scss';
import CalendarIcon from '../../../../shared/components/Icons/CalendarIcon';

const DateInput = ({
  required,
  input,
  inputID,
  label,
  labelClassName,
  inputClassName,
  placeholder,
  disabledBefore,
  hidden,
  meta: {
    form, dispatch, error,
  },
}) => {
  if (hidden) {
    return null;
  }
  return (
    <div className="form-group row date-picker">
      {label && (
        <label htmlFor={inputID} className={labelClassName}>
          {label}
          {' '}
          {required && <span className="requiredField">*</span>}
        </label>
      )}
      <div className={`${inputClassName}`}>
        <DayPickerInput
          {...input}
          placeholder={placeholder || (required ? 'required' : '')}
          id={inputID}
          inputProps={{ readOnly: true }}
          onDayChange={input.onChange}
          dayPickerProps={{
            disabledDays: [
              { daysOfWeek: [0, 6] },
              { before: new Date(disabledBefore) },
            ],
            fromMonth: new Date(),
          }}
          formatDate={(date) => format(date, 'MMMM do yyyy')}
        />
        <div className="date-picker__icon">
          <CalendarIcon fill="#808184" width={22} height={22} />
        </div>
        {input.value && (
          <button
            onClick={(e) => {
              e.preventDefault();
              dispatch(change(form, input.name, null));
            }}
            className="btn btn-clear date-picker__clear"
          >
            ×
          </button>
        )}
        {error && <div className="invalid-feedback">{error}</div>}
      </div>
    </div>
  );
};

DateInput.propTypes = {
  input: PropTypes.shape(fieldInputPropTypes).isRequired,
  meta: PropTypes.shape(fieldMetaPropTypes).isRequired,
  label: PropTypes.string,
  autoFocus: PropTypes.bool,
  required: PropTypes.bool,
  inputID: PropTypes.string,
  placeholder: PropTypes.string,
  labelClassName: PropTypes.string,
  inputClassName: PropTypes.string,
  disabledBefore: PropTypes.string,
  hidden: PropTypes.bool,
};
DateInput.defaultProps = {
  label: null,
  autoFocus: false,
  required: false,
  inputID: null,
  placeholder: null,
  labelClassName: 'text-left col-12',
  inputClassName: 'col-12',
  disabledBefore: null,
  hidden: false,
};

export default DateInput;
